import axios from 'axios'

export interface CommunityHeaderConfig {
  type: 'default' | 'ssi' | 'custom',
  defaultHeader: {
    label: string,
    labelMobile: string,
    url: string,
    backgroundColor: string,
    linkColor: string,
    logoUrl: string
  },
  ssiHeader: {
    url: string
  },
  customHeader: {
    html: string
  }
}

export interface CommunityFooterConfig {
  type: 'default' | 'ssi' | 'custom',
  ssiFooter: {
    url: string,
  },
  customFooter: {
    html: string
  }
}

export interface ThirdPartyScripts {
  head: string,
  bodyStart: string,
  bodyEnd: string,
  ssiUrl: string
}

export const getCommunityHeaderConfig = async (): Promise<CommunityHeaderConfig> => {
  const res = await axios.get('/configuration/getHeader')
  return res.data
}

export const updateCommunityHeaderConfig = async (header: CommunityHeaderConfig): Promise<CommunityHeaderConfig> => {
  const res = await axios.post('/configuration/updateHeader', header)
  return res.data
}

export const getCommunityFooterConfig = async (): Promise<CommunityFooterConfig> => {
  const res = await axios.get('/configuration/getFooter')
  return res.data
}

export const updateCommunityFooterConfig = async (header: CommunityFooterConfig): Promise<CommunityFooterConfig> => {
  const res = await axios.post('/configuration/updateFooter', header)
  return res.data
}

export const getThirdPartyScriptConfig = async (): Promise<ThirdPartyScripts> => {
  const res = await axios.get('/settings/thirdPartyScripts/getScripts')
  return res.data
}

export const updateThirdPartyScriptConfig = async (scripts: ThirdPartyScripts): Promise<void> => {
  await axios.post('/settings/thirdPartyScripts/update', scripts)
}
